import React, { useEffect, useState } from 'react';
import { LottieAnimation } from '../lottie-animation';

type Props = {
  width?: number;
  height?: number;
} & React.InputHTMLAttributes<HTMLInputElement>;

export function LoadingAnimation({ width, height }: Props): JSX.Element {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    import('./loading.json')
      .then((data) => {
        setAnimationData(data.default);
      })
      .catch((error) => console.error('Error loading animation data:', error));
  }, []);

  return (
    <LottieAnimation
      animationData={animationData}
      width={width}
      height={height}
      loop
      autoplay
    />
  );
}
